<template>
    <div>
        <transition name="login">
            <div v-if="loginIsShow" id="headLoginBox">
                <div id="headLoginWrap" :class="{bt:!$isZh()}">                                     
                    <img style="position: absolute; top: 0; left: 0; height: 643px;" src="@/assets/img/register/login1.png"/>                
                    <div style="width: 1px; margin: 0 70px 0 560px; background: #d8dce6;"></div>
                    <div>
                        <div style="margin-bottom: 60px; font-size: 28px; font-weight: 500; color: #333; text-align: center;">{{$t('message.welcomeLogin')}}</div>
                        <el-tabs v-model="activeName" 
                                 style="font-size: 18px;" 
                        >                      
                            <el-tab-pane :label="$t('message.pswLogin')" name="pswLogin"></el-tab-pane>
                            <el-tab-pane :label="$t('message.codeLogin')" name="codeLogin"></el-tab-pane>
                        </el-tabs>
                        <!-- <p class="headLoginTit">
                            <span>{{$t('message.accountLogin')}}</span>
                            <a v-if="$i18n.locale === 'zhCHS'"
                            class="headLogisticsCircle"
                            target="_blank"
                            :href="$getSupplierUrl()">{{$t('message.logisticsCircle')}}</a>
                        </p> -->
                        <template v-if="activeName === 'pswLogin'">
                            <div class="headLoginInputBox">
                                <el-input   v-model.trim="username"
                                            class="headLoginUser"
                                            autofocus
                                            size="medium"
                                            :placeholder="$t('message.accountInfoModifyUserName1')">
                                </el-input>       
                                <!-- <i class="iconfont icon-yonghu1"></i> -->
                            </div>
                            <div class="headLoginInputBox">
                                <el-input   v-model.trim="password"
                                            class="headLoginUser"
                                            size="medium"
                                            type="password"
                                            :placeholder="$t('message.loginPassword')"
                                            @keyup.native.enter="loginClickFn()">
                                </el-input>          
                                <!-- <i class="iconfont icon-mima"></i> -->
                            </div>
                        </template>
                        <template v-else>
                            <div class="headLoginInputBox">
                                <el-input   v-model.trim="emailMobile"
                                            class="headLoginUser"
                                            autofocus
                                            size="medium"
                                            :placeholder="$t('message.pleaseEnterPhoneNumber1')">
                                </el-input>       
                                <!-- <i class="iconfont icon-yonghu1"></i> -->
                            </div>
                            <div class="headLoginInputBox" style="display: flex; justify-content: space-between;">
                                <el-input   v-model.trim="verificationCode "
                                            class="headLoginUser"
                                            :style="{flex:'1'}"
                                            size="medium"
                                            :placeholder="$t('message.iptVerificationCode')"
                                            @keyup.native.enter="loginClickFn()">
                                </el-input>   
                                <el-button  type="primary"
                                            style="height: 36px; margin-left: 15px;"
                                            :disabled="loading60"
                                            @click="sendCode()">
                                    <span v-if="loading60">
                                        <span v-if="$getCookie('i18n') === 'zhCHS'">{{number60}}秒后重新发送</span>
                                        <span v-else>Send again after {{number60}} seconds</span>
                                    </span>
                                    <span v-else>{{$t('message.sendCode')}}</span>                                
                                </el-button>       
                                <!-- <i class="iconfont icon-mima"></i> -->
                            </div>
                        </template>
                        <div class="headAutoLoginDiv">
                            <div class="headAutoLoginBox">
                                <input  id="headAutoLoginBtn"
                                        v-model="autoLoginType"
                                        type="checkbox">
                                <label>{{$t('message.autoLogin')}}</label>
                            </div>
                            <div class="forgetPwd">
                                <router-link to="/RetrievePassword" @click.native="closeLoginFn();$bigData('登录-忘记密码', '登录-忘记密码', '1')">
                                    {{$t('message.forgetPassword')}}
                                </router-link>
                            </div>
                        </div>
                        <el-button  v-if="!isLoading"
                                    :disabled="!policy"
                                    href="javascript:void(0);"
                                    type="primary"
                                    class="headLoginConfirmBtn"
                                    @click="loginClickFn">
                            {{$t('message.login')}}
                        </el-button>
                        <el-button  v-else
                                    href="javascript:void(0);"
                                    class="headLoginConfirmBtn loading">{{$t('message.loggingIn')}}</el-button>
                        <div class="headAutoLoginDiv">
                            <div class="headAutoLoginBox">
                                <input  id="headAutoLoginBtn"
                                        v-model="policy"
                                        type="checkbox"/>
                                <label v-if="$getCookie('i18n') === 'zhCHS'" 
                                       style="display: inline-block; width: 396px; word-break: break-all;">登录代表您同意<span style="color: #29abe2; cursor: pointer;" @click="go()">《三脚猫用户协议》</span>以及<span style="color: #29abe2; cursor: pointer;" @click="go(1)">《三脚猫隐私条款》</span></label>
                                <span  v-else
                                       style="display: inline-block; width: 396px; word-break: break-all;">
                                    Login means that you agree to the <span style="color: #29abe2; cursor: pointer;" @click="go()">《3J-mall user agreement》</span> and <span style="color: #29abe2; cursor: pointer;" @click="go(1)">《the 3J-mall privacy terms》</span>                       
                                </span>
                                <!-- <span style="color:#29abe2;cursor: pointer;">隐私条款》</span> -->
                            </div>                
                        </div> 
                        <div style="display: flex; justify-content: space-between; margin-top: 30px;">
                            <a  v-if="$i18n.locale === 'zhCHS'"
                                class="headLoginRegister"
                                :href="$getSupplierUrl()"
                                target="_blank"
                                @click="$bigData('登录-物流圈登录', '登录-物流圈登录', '1')">
                                {{$t('message.logisticsCircle1')}}
                            </a> 
                            <div v-else style=""></div> 
                            <router-link    class="headLoginRegister"
                                            to="/Register"
                                            @click.native="closeLoginFn();$bigData('登录-注册', '登录-注册', '1')">
                                {{$t('message.noAccount')}}
                            </router-link>
                        </div>    
                    
                        <i v-if="!forbidClose.includes($route.name)"
                           class="headLoginClose iconfont icon-chahao" 
                           @click="closeLoginFn"></i>
                    </div>
                    
                </div>
            </div>
        
        </transition> 
        <el-dialog  title=""
                    :visible.sync="bindDialog"                           
                    :close-on-click-modal="false"
                    :before-close="bclose"                             
                    width="430px">
            <div style="width: 90%; font-size: 18px;">为了方便您使用手机号/邮箱登录，请绑定<span v-if="registerMobile === '0'">手机号</span><span v-if="registerEmail === '0' && registerMobile === '0'">和</span><span v-if="registerEmail === '0'">邮箱</span>！</div>   
            <template v-if="registerMobile === '0'">
                <div style="display: flex; align-items: center; justify-content: center; width: 100%; margin-top: 20px;">
                    <span style="width: 80px; font-size: 16px;"><span style="color: red;">*</span>手机号：</span>
                    <el-input   v-model.trim="noticeMobile"  
                                size="medium"
                                style="flex: 1; height: 35px; margin-left: 10px;"/>
                </div>
                <div style="display: flex; align-items: center; justify-content: center; width: 100%; margin-top: 20px;">
                    <span :style="{fontSize: '16px',width:'80px'}"><span style="color: red;">*</span>验证码：</span>
                    <el-input   v-model.trim="mobileVerifyCode"  
                                size="medium"
                                style="flex: 1; height: 35px; margin-left: 10px;"/>
                    <el-button  type="primary"
                                style="height: 36px; margin-left: 15px;"
                                :disabled="loadingMobile60"
                                @click="sendCode1('noticeMobile');$bigData('登录-绑定-手机号-获取验证码','登录-绑定-手机号-获取验证码',noticeMobile)">
                        <span v-if="loadingMobile60">
                            <span v-if="$getCookie('i18n') === 'zhCHS'">{{mobilenumber60}}秒后重新发送</span>
                            <span v-else>Send again after {{mobilenumber60}} seconds</span>
                        </span>
                        <span v-else>{{$t('message.sendCode')}}</span>                                
                    </el-button>                    
                </div> 
            </template>
            <template v-if="registerEmail === '0'">
                <div style="display: flex; align-items: center; justify-content: center; width: 100%; margin-top: 20px;">
                    <span style="width: 80px; font-size: 16px;"><span style="color: red;">*</span>邮箱：</span>
                    <el-input   v-model.trim="noticeEmail"  
                                size="medium"
                                style="flex: 1; height: 35px; margin-left: 10px;"/>
                </div>
                <div style="display: flex; align-items: center; justify-content: center; width: 100%; margin-top: 20px;">
                    <span :style="{fontSize: '16px',width:'80px'}"><span style="color: red;">*</span>验证码：</span>
                    <el-input   v-model.trim="emailVerifyCode"  
                                size="medium"
                                style="flex: 1; height: 35px; margin-left: 10px;"/>
                    <el-button  type="primary"
                                style="height: 36px; margin-left: 15px;"
                                :disabled="loadingemail60"
                                @click="sendCode1('noticeEmail');$bigData('登录-绑定-邮箱-获取验证码','登录-绑定-邮箱-获取验证码',noticeEmail)">
                        <span v-if="loadingemail60">
                            <span v-if="$getCookie('i18n') === 'zhCHS'">{{emailnumber60}}秒后重新发送</span>
                            <span v-else>Send again after {{emailnumber60}} seconds</span>
                        </span>
                        <span v-else>{{$t('message.sendCode')}}</span>                                
                    </el-button>                    
                </div> 
            </template>             
            <span slot="footer">
                <el-button type="text"
                           size="medium"
                           style="font-size: 16px;"
                           @click="go(2);$bigData('登录-绑定-暂不绑定','登录-绑定-暂不绑定','1')">暂不绑定</el-button>
                <el-button type="primary"
                           style="min-width: 100px; margin-left: 28px; font-size: 16px;"
                           size="medium"  
                           @click="bindInfo()">绑定</el-button>
            </span>
                        
        </el-dialog>
        <el-dialog  title=""
                    :visible.sync="tipDailog"                           
                    :close-on-click-modal="false"                             
                    width="370px"
                    @close="go(2)">        
            <div style="display: flex; align-items: center; justify-content: center; width: 60px; height: 60px; margin: auto; background: rgba(103, 194, 58, 1); border-radius: 60px;">
                <i class="el-icon-check" style="font-size: 40px; font-weight: 800; color: #fff;"></i>
            </div>
            <h3 style="width: 250px; margin: 20px auto; text-align: center;">
                恭喜您，手机号和邮箱绑定成功！
            </h3>
            
        </el-dialog>

        <el-dialog  title=""
                    :visible.sync="verDailog"                           
                    :close-on-click-modal="false" 
                    :show-close="false"
                    width="350px"
        >                              
            <div style="display: flex; align-items: center; justify-content: center; width: 60px; height: 60px; margin: auto; background: rgba(103, 194, 58, 1); border-radius: 60px;">
                <i class="el-icon-check" style="font-size: 40px; font-weight: 800; color: #fff;"></i>
            </div>
            <h3 style="margin: 10px auto; text-align: center; word-break: break-word;">
                {{$t('message.goperson')}}
            </h3>
            <h3 style="margin: 10px auto; text-align: center;">
                <el-button type="primary" @click="go(4)">{{$t('message.confirm')}}</el-button>
            </h3>
                
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :visible.sync="yuzhiDialog"
                :before-close="bclose"
                width="720px"
                top="5vh"     
                :show-close="false"           
                custom-class="yuzhi">
            <div style="line-height: 30px;">
                <p style="font-size: 18px;">{{$t('message.yindao1')}}</p>
                <p style="margin-top: 15px;">{{$t('message.yindao2')}}</p>
                <p >{{$t('message.yindao3')}}</p>
                <p >{{$t('message.yindao4')}}</p>
                <p>{{$t('message.yindao5')}}</p>
                <p >{{$t('message.yindao6')}}</p>
                <p >{{$t('message.yindao7')}}</p>
               
              
            </div>
            <span slot="footer">
                <el-button  size="large" 
                            type="primary" 
                            @click="go(3)">{{$t('message.agree')}}</el-button>               
            </span>
        </el-dialog>
        <el-dialog  title=""
                    :visible.sync="yuzhiDialog1"                           
                    :close-on-click-modal="false" 
                    :show-close="false"
                    width="460px"
        >                              
            
            <h3 style="width: 200px; margin-top: -20px; font-size: 16px; color: rgba(24, 24, 24, 1); text-align: left; word-break: break-word;">
                {{$t('message.tip')}}
            </h3>
            <div v-if="$i18n.locale==='en'" style="margin-top: 10px; line-height: 28px;">               
                <div    v-for="(v,i) in portFeeTemplateChange"
                        :key="i">
                    <p style="">Dear users, the system {{v.endPort}} port charging rules have the following changes, please check:</p>
                    <p  v-for="(v1,j) in v.changeDetailList"
                        :key="j">                                            
                        The unit price of {{v1.feeName}} is modified from  {{v1.oldPrice}} to {{v1.newPrice}}，and the minimum charge is modified from {{v1.oldMinimumAmount}} to {{v1.newMinimumAmount}} 
                    </p>
                    <p v-if="v.cargoFeeChange === '1'">The stepped charging rule of storage fee has changed. Please check the specific details when publishing the forecast.</p>
                </div>                      
                <p>You can carefully check the revised fee list again when making the forecast. Please understand that the change of the fee list will bring you no change. Thank you!</p>
            </div> 
            <div v-else style="line-height: 28px;">           
                <div    v-for="(v,i) in portFeeTemplateChange"
                        :key="i">
                    <p style="margin-top: 10px;">亲爱的用户，系统港口收费规则有如下变更，请查看：</p>
                    <p  v-for="(v1,j) in v.changeDetailList"
                        :key="j">                       
                        {{v1.feeName}}单价从{{v1.oldPrice}}修改为{{v1.newPrice}}，最低收费从{{v1.oldMinimumAmount}}修改为{{v1.newMinimumAmount}} 
                    </p>
                    <p v-if="v.cargoFeeChange === '1'">仓储费阶梯式收费规则发生变化，请发布预报时查看具体详情。</p>
                </div>
                <p>你可以在发预报时，再次仔细查看修改后的费用清单，本次收费清单变动给你带来的不变敬请谅解，谢谢！</p>
            </div> 
            
            <h3 style="margin: 10px auto; text-align: right;">
                <el-button type="primary" @click="go(5)">{{$t('message.igotit')}}</el-button>
            </h3>
                
        </el-dialog>
    </div>
    
</template>

<script>
    export default {
        name: 'Login',
        data() {
            return {
                mobileRegular: this.$store.state.Regular.mobile,// 手机号正则
                emailRegular: this.$store.state.Regular.email,// 邮箱正则
                username: '',// 用户名
                password: '',// 密码
                autoLoginType: true,// 自动登录
                policy: true,// 自动登录
                isLoading: false,// 登录中
                activeName: 'pswLogin',
                loading60: false,
                number60: 60,
                inertval: null,
                emailMobile: '',
                verificationCode: '',
                emailSendCount: 1,

                bindDialog: false, // 绑定框
                loadingemail60: false, // 邮箱实在loading
                emailVerifyCode: '', // 邮箱验证码
                emailnumber60: 60, // 邮箱60秒
                noticeEmail: '', // 绑定邮箱
                inertvalMobile: null,

                noticeMobile: '', // 绑定手机
                loadingMobile60: false, // 邮箱实在loading
                mobileVerifyCode: '', // 邮箱验证码
                mobilenumber60: 60, // 邮箱60秒
                inertvalemail: null,

                registerEmail: '', // 0显示 1隐藏
                registerMobile: '', // 0显示 1隐藏
                emailSendCount1: 1, // 绑定邮箱发送次数
                tipDailog: false, // 绑定成功弹框
                yuzhiDialog: false, // 预热协议弹框
                overseasImportManual: '',
                verDailog: false, // 前往完善信息弹框
                yuzhiDialog1: false, // 小恶魔
                portFeeTemplateChange: [], // 小恶魔数据
                forbidClose: ['SmartProducts', 'ImportQuery', 'AirlineDirect', 'AirlineDirectChangeDate'], // 需要
            };
        },
        computed: {
            // 获取登录框状态
            loginIsShow() {
                return this.$store.state.Login.loginIsShow;
            }
        },
        watch: {
            activeName(n) {
                if (n === 'pswLogin') {
                    this.$bigData('登录-密码登录', '登录-密码登录', '1');
                } else {
                    this.$bigData('登录-验证码登录', '登录-验证码登录', '1');
                }
            }
        },
        methods: {
            bclose(done) {
                done();
                location.reload();         
            },
            go(type) {
                if (type === 1) {
                    this.$bigData('登录-隐私条款', '登录-隐私条款', '1');
                    if (this.$getCookie('i18n') === 'zhCHS') {
                        open('/PrivacyPolicy');
                    } else {
                        open('/PrivacyPolicyEn');
                    }
                } else if (type === 2) {
                    window.top.location.reload(); 
                } else if (type === 3) {
                    this.$bigData('登录-海外-开展业务', '登录-海外-开展业务', '1');
                    this.$ajax({
                        url: '/personalCenterHandler/common/PersonalCenterCommonHandler.ashx',
                        data: {
                            act: 'postElecProtocolData',// 提交电子协议认证的数据
                            type: '3',// 0-个人买家出口电子协议、1-个人供应商出口电子协议、2-海外用户进口电子协议、3-海外用户进口操作手册
                        },
                        success: () => {    
                            location.replace('/personalCenter/operationCenter/cargoQuery/importBusiness/ImportBusinessMain?type=0');
                        }   
                    });
                    
                } else if (type === 4) {
                    this.$bigData('登录-海外-完善信息', '登录-海外-完善信息', '1');
                    location.replace('/personalCenter/PersonalCenterMain/personalInfo/AccountInfoModifyEn');
                } else if (type === 5) {
                    this.$bigData('登录-海外-费用变更-我知道了', '登录-海外-费用变更-我知道了', '1');
                    location.replace('/personalCenter/operationCenter/cargoQuery/importBusiness/ImportBusinessMain?type=0'); 
                } else {
                    this.$bigData('登录-用户协议', '登录-用户协议', '1');
                    if (this.$getCookie('i18n') === 'zhCHS') {
                        open('/UserAgreement');
                    } else {
                        open('/UserAgreementEn');
                    }
                } 
                 
            },
            // 点击登录
            loginClickFn() {
                if (this.activeName === 'pswLogin') {
                    // 密码正则验证
                    if (!this.username) {
                        this.$Alert({
                            msg: this.$t('message.accountInfoModifyUserName1')
                        });
                        return;
                    }
                    // 密码正则验证
                    if (!this.password) {
                        this.$Alert({
                            msg: this.$t('message.loginPassword')
                        });
                        return;
                    }
                } else {
                    if (!this.mobileRegular.test(this.emailMobile) && !this.emailRegular.test(this.emailMobile)) {
                        this.$Alert({
                            msg: this.$t('message.pleaseEnterPhoneNumber2')
                        });
                        return;
                    }
                    if (!this.verificationCode) {
                        this.$Alert({
                            msg: this.$t('message.iptVerificationCode')
                        });
                        return;
                    }
                }
                this.$bigData('登录-登录','登录-登录',this.activeName === 'pswLogin' ? this.username : this.emailMobile);
                
                this.$ajax({
                    url: '/RegisterHandler/RegisterHandler.ashx',
                    data: {
                        act: 'postUserLoginDataV2',
                        loginType: this.activeName === 'pswLogin' ? '0' : '1',// 登录类型 0-密码登录、1-验证码登录
                        loginName: this.activeName === 'pswLogin' ? this.username : '',// 用户名、邮箱、手机号（密码登录传值）
                        password: this.activeName === 'pswLogin' ? this.password : '',// 密码（密码登录传值）
                        emailMobile: this.activeName === 'pswLogin' ? '' : this.emailMobile,// 邮箱、手机号（验证码登录传值）
                        verificationCode: this.activeName === 'pswLogin' ? '' : this.verificationCode,// 验证码（验证码登录传值）
                        autoLoginType: this.autoLoginType ? '1' : '0',// 30天自动登录 0-N、1-Y
                        tokenType: '0',// Token开关 0-关闭、1-IOS_Token、2、Android_Token
                    },
                    beforeSend: () => {
                        this.isLoading = true;
                    },
                    complete: () => {
                        this.isLoading = false;
                    },
                    success: async (res) => {                    
                        if (res.success.noAccount === '1') {
                            let isMoileOrEmail = false;
                            if (this.activeName !== 'pswLogin') {
                                isMoileOrEmail = true;
                            } else {
                                if (this.mobileRegular.test(this.username) || this.emailRegular.test(this.emailMobile)) {
                                    isMoileOrEmail = true;    
                                }
                            }
                            this.$alert(isMoileOrEmail ? this.$t('message.noRegistered') : this.$t('message.noRegistered1'),this.$t('message.tip'),{
                                callback: (action) => {                             
                                    if (action === 'confirm') { 
                                        this.closeLoginFn();                         
                                        this.$router.push({path: '/Register'});                                  
                                    }                            
                                }
                            }); 
                            return;                       
                        }  
                        if (res.success.noAccount === '2') {
                            this.$alert(this.$t('message.loginCircle'),this.$t('message.tip'),{
                                confirmButtonText: this.$t('message.confirm'),
                                callback: (action) => {                             
                                    if (action === 'confirm') {                       
                                        window.open(this.$getSupplierUrl());                                
                                    }                            
                                }
                            });
                            return;  
                        }                               
                        // 获取登录状态
                        // 海外用户标志 0-中国大陆、1-非中国大陆
                        // 海外用户币制 CNY-人民币、USD-美金、EUR-欧元
                        const {overseasType, currencyType} = await this.$isLogin();
                        // 切换币种
                        this.$setCookie('currency', currencyType || 'CNY', 365);
                        // 切换语言
                        if (overseasType) {// 海外
                            this.$setCookie('i18n', 'en', 365);
                        } else {// 大陆
                            this.$setCookie('i18n', 'zhCHS', 365);
                        }
                        if (this.$store.state.Login.loginData.userType !== '5') {
                            this.getBindType();                      
                        } else {
                            if (this.$store.state.Login.loginData.completeRegisterType !== '2') {
                                this.verDailog = true;
                            } else {
                                this.getBindType1();
                                // window.top.location.replace('/personalCenter/operationCenter/cargoQuery/importBusiness/ImportBusinessMain?type=0'); 
                            }
                        }
                        
                       
                    }
                });
                
            },
            getBindType1() {
                this.$ajax({
                    url: '/personalCenterHandler/common/PersonalCenterCommonHandler.ashx',
                    data: {
                        act: 'getAccountVerificationWay',           
                    },
                    success: (res) => {               
                        this.overseasImportManual = res.success.overseasImportManual; 
                        this.closeLoginFn();    
                        if (this.overseasImportManual === '0') {                       
                            this.yuzhiDialog = true;                    
                        } else {
                            this.getBindType2(); 
                            // window.top.location.replace('/personalCenter/operationCenter/cargoQuery/importBusiness/ImportBusinessMain?type=0');  
                        } 
                                          
                    }
                });

            },
            getBindType2() {
                this.$ajax({
                    url: '/SmartProductsHandler/Home/NoticeMessageHandler.ashx',
                    data: {
                        act: 'getLittleDevilAssistantManagerData',           
                    },
                    success: (res) => {               
                        this.portFeeTemplateChange = res.success.portFeeTemplateChange || [];
                        if (this.portFeeTemplateChange.length) {
                            this.yuzhiDialog1 = true; 
                        } else {
                            window.top.location.replace('/personalCenter/operationCenter/cargoQuery/importBusiness/ImportBusinessMain?type=0'); 
                        }                           
                    }
                });

            },
            bindInfo() {
                if (this.registerMobile === '0' && this.registerEmail === '0') {
                    if (!this.mobileRegular.test(this.noticeMobile)) {
                        this.$Alert({
                            msg: this.$t('message.errMobile')
                        });
                        return;    
                    }
                    if (!this.emailRegular.test(this.noticeEmail)) {
                        this.$Alert({
                            msg: this.$t('message.errEmail')
                        });
                        return;
                    }

                    if (!this.mobileVerifyCode) {
                        this.$Alert({
                            msg: '请输入手机验证码'
                        });
                        return;
                    }
                    if (!this.emailVerifyCode) {
                        this.$Alert({
                            msg: '请输入邮箱验证码'
                        });
                        return;
                    }
                    this.$bigData('登录-绑定-绑定','登录-绑定-绑定','1');
                    Promise.all([new Promise((r,j) => {
                        this.$ajax({
                            url: '/personalCenterHandler/PersonalInfo/PersonalInfoHandler.ashx',
                            data: {
                                act: 'postModifyRegisterEmailMobileData',// 提交修改注册邮箱或手机的数据
                                method: 'mobile',// email-邮箱、mobile-手机
                                verificationCode: this.mobileVerifyCode,// 验证码
                                sendInfo: this.noticeMobile,// 邮箱、手机号          
                            },
                            success: () => {                      
                                r();                      
                            },
                            error: () => {
                                j();
                            },
                            errCallback: () => {
                                j();
                            }
                        }); 
                    }),new Promise((r,j) => {
                        this.$ajax({
                            url: '/personalCenterHandler/PersonalInfo/PersonalInfoHandler.ashx',
                            data: {
                                act: 'postModifyRegisterEmailMobileData',// 提交修改注册邮箱或手机的数据
                                method: 'email',// email-邮箱、mobile-手机
                                verificationCode: this.emailVerifyCode,// 验证码
                                sendInfo: this.noticeEmail,// 邮箱、手机号          
                            },
                            success: () => {                      
                                r();                      
                            },
                            error: () => {
                                j();
                            },
                            errCallback: () => {
                                j();
                            }
                        }); 
                    })]).then(() => {
                        this.tipDailog = true;
                    }).catch(() => {

                    });
                } else if (this.registerMobile === '0') {
                    if (!this.mobileRegular.test(this.noticeMobile)) {
                        this.$Alert({
                            msg: this.$t('message.errMobile')
                        });
                        return;    
                    }
                

                    if (!this.mobileVerifyCode) {
                        this.$Alert({
                            msg: '请输入手机验证码'
                        });
                        return;
                    }
                    this.$bigData('登录-绑定-绑定','登录-绑定-绑定','1');
                    this.$ajax({
                        url: '/personalCenterHandler/PersonalInfo/PersonalInfoHandler.ashx',
                        data: {
                            act: 'postModifyRegisterEmailMobileData',// 提交修改注册邮箱或手机的数据
                            method: 'mobile',// email-邮箱、mobile-手机
                            verificationCode: this.mobileVerifyCode,// 验证码
                            sendInfo: this.noticeMobile,// 邮箱、手机号          
                        },
                        success: () => {                      
                            this.tipDailog = true;                      
                        }
                    });
                } else {
                    if (!this.emailRegular.test(this.noticeEmail)) {
                        this.$Alert({
                            msg: this.$t('message.errEmail')
                        });
                        return;
                    }

                 
                    if (!this.emailVerifyCode) {
                        this.$Alert({
                            msg: '请输入邮箱验证码'
                        });
                        return;
                    }
                    this.$bigData('登录-绑定-绑定','登录-绑定-绑定','1');
                    this.$ajax({
                        url: '/personalCenterHandler/PersonalInfo/PersonalInfoHandler.ashx',
                        data: {
                            act: 'postModifyRegisterEmailMobileData',// 提交修改注册邮箱或手机的数据
                            method: 'email',// email-邮箱、mobile-手机
                            verificationCode: this.emailVerifyCode,// 验证码
                            sendInfo: this.noticeEmail,// 邮箱、手机号           
                        },
                        success: () => {          
                            this.tipDailog = true;                                                
                        }
                    });
                } 
                
               

                
            },
            getBindType() {
                this.$ajax({
                    url: '/personalCenterHandler/common/PersonalCenterCommonHandler.ashx',
                    data: {
                        act: 'getAccountVerificationWay',           
                    },
                    success: (res) => {  
                        
                        this.registerEmail = res.success.registerEmail;   
                        this.registerMobile = res.success.registerMobile; 
                        this.noticeEmail = res.success.noticeEmail;  
                        this.noticeMobile = res.success.noticeMobile ? res.success.noticeMobile.split('-')[1] : '';                  
                        if (res.success.registerEmail === '0' || res.success.registerMobile === '0') {
                            this.bindDialog = true;
                            this.closeLoginFn();
                        } else {
                            window.top.location.reload(); 
                        }                    
                    }
                });
            },

            sendCode1(t) {
                if (t === 'noticeMobile' && !this.mobileRegular.test(this[t])) {
                    this.$Alert({
                        msg: this.$t('message.errMobile')
                    });
                    return;
                  
                    
                }
                if (t === 'noticeEmail' && !this.emailRegular.test(this[t])) {
                    this.$Alert({
                        msg: this.$t('message.errEmail')
                    });
                    return;

                }

                if (t === 'noticeMobile') {
                    this.loadingMobile60 = true;
                    this.inertvalMobile = setInterval(() => {
                        this.mobilenumber60 = this.mobilenumber60 - 1; 
                        if (this.mobilenumber60 === 0) {
                            clearInterval(this.inertvalMobile);
                            this.loadingMobile60 = false;
                            this.mobilenumber60 = 60;
                        }              
                    }, 1000);
                } else {
                    this.loadingemail60 = true;
                    this.inertvalemail = setInterval(() => {
                        this.emailnumber60 = this.emailnumber60 - 1; 
                        if (this.emailnumber60 === 0) {
                            clearInterval(this.inertvalemail);
                            this.loadingemail60 = false;
                            this.emailnumber60 = 60;
                        }              
                    }, 1000);
                }
                         
                this.$ajax({
                    url: '/personalCenterHandler/common/PersonalCenterCommonHandler.ashx',
                    data: {
                        act: 'getAccountVerificationCodeData',// 获取验证码
                        method: t === 'noticeMobile' ? 'mobile' : 'email',// email-邮箱、mobile-手机
                        sendInfo: t === 'noticeMobile' ? '+86-' + this.noticeMobile : this.noticeEmail,// 邮箱、手机号
                        emailSendCount: this.emailSendCount1// 获取邮箱验证码点击的次数
                    },
                    errCallback: () => {
                        if (t === 'noticeMobile') {
                            clearInterval(this.inertvalMobile);
                            this.loadingMobile60 = false;
                            this.mobilenumber60 = 60;   
                        } else {
                            clearInterval(this.inertvalemail);
                            this.loadingemail60 = false;
                            this.emailnumber60 = 60; 
                        }
                                     
                    },
                    complete: () => {
                        // this.registerLoading = false;
                        if (t === 'noticeEmail') {
                            this.emailSendCount1++;
                        }
                        
                    },              
                    success: () => {
                       
                       
                    }
                });
            },
            sendCode() {        
                if (!this.mobileRegular.test(this.emailMobile) && !this.emailRegular.test(this.emailMobile)) {
                    this.$Alert({
                        msg: this.$t('message.pleaseEnterPhoneNumber2')
                    });
                    return;
                }
                this.loading60 = true;
                this.inertval = setInterval(() => {
                    this.number60 = this.number60 - 1; 
                    if (this.number60 === 0) {
                        clearInterval(this.inertval);
                        this.loading60 = false;
                        this.number60 = 60;
                    }              
                }, 1000); 
                this.$bigData('登录-验证码登录-获取验证码', '登录-验证码登录-获取验证码', this.emailMobile); 
                this.$ajax({
                    url: '/RegisterHandler/RegisterHandler.ashx',
                    data: {
                        act: 'getNoLoginVerificationCodeData',// 提交注册
                        method: this.emailMobile.includes('@') ? 'email' : 'mobile',// 方式 email-邮箱、mobile-手机
                        sendInfo: this.emailMobile,// 邮箱、手机号
                        emailSendCount: this.emailSendCount // 获取邮箱验证码点击的次数
                    },
                    beforeSend: () => {
                        // this.registerLoading = true;
                    },
                    success: () => {
                       
                    },
                    errCallback: () => {
                        clearInterval(this.inertval);
                        this.loading60 = false;
                        this.number60 = 60;                
                    },
                    complete: () => {
                        // this.registerLoading = false;
                        if (this.emailMobile.includes('@')) {
                            this.emailSendCount++;
                        }
                        
                    }
                });           
            },
            // 关闭登录框
            closeLoginFn() {
                this.$store.commit('Login/loginIsShow', false);
            }
        }
    };
</script>
<style scoped>
    .login-enter-active,
    .login-leave-active {
        transition: opacity 0.3s;
    }

    .login-enter,
    .login-leave-to {
        opacity: 0;
    }
</style>
<style lang="scss" scoped>
    /deep/ .el-dialog__body {
        padding: 10px 20px;
    }

    /deep/ .el-tabs__nav-scroll {
        display: flex;
        justify-content: center;
    }

    #headLoginBox {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
    }

    #headLoginWrap {
        position: relative;
        top: 50%;
        left: 50%;
        display: flex;
        width: 1050px;
        // height: 420px;
        padding: 70px 40px;
        overflow: hidden;
        background-color: white;
        border-radius: 5px;
        transform: translate3d(-50%, -50%, 0);

        /deep/ .el-tabs__item {
            font-size: 18px;
        }
    }

    #headLoginWrap.bt {
        padding-bottom: 38px;
    }

    #headLoginWrap .headLoginTit {
        padding: 28px 0 9px 5px;
        font-size: 14px;
        color: #4d4d4d;
        border-bottom: 1px solid rgba(41, 171, 226, 0.75);
    }

    #headLoginWrap .headLoginTit .headLogisticsCircle {
        margin-left: 37px;
        color: #4d4d4d;
    }

    #headLoginWrap .headLoginTit .headLogisticsCircle:hover {
        color: #29abe2;
    }

    #headLoginWrap .headLoginInputBox {
        position: relative;
        width: 420px;
        height: 40px;
        margin: 27px auto 0;
        // border: 1px solid rgba(77, 77, 77, 0.5);
        // border-radius: 4px;
    }

    .headLoginUser /deep/ input {
        border: 1px solid #d8dce6;

        &:focus {
            border-color: #409eff;
        }
    }

    #headLoginWrap .headLoginInputBox i.icon-yonghu1 {
        position: absolute;
        top: 8px;
        left: 12px;
        font-size: 22px;
    }

    #headLoginWrap .headLoginInputBox i.icon-mima {
        position: absolute;
        top: 8px;
        left: 12px;
        font-size: 22px;
    }

    #headLoginWrap .headAutoLoginDiv {
        position: relative;
        display: flex;
        margin-top: 17px;
        overflow: hidden;
    }

    #headLoginWrap .headAutoLoginBox {
        position: relative;
        flex-wrap: wrap;
        // display: flex;
        align-items: center;
        cursor: pointer;

        /* float: left; */
        user-select: none;
    }

    #headLoginWrap #headAutoLoginBtn {
        position: relative;
        top: 0;
        width: 16px;
        height: 16px;
        margin-right: 4px;
        vertical-align: top;
    }

    #headLoginWrap #headAutoLoginBtn + label {
        position: relative;
        left: -2px;
    }

    #headLoginWrap .forgetPwd {
        position: relative;
        display: flex;
        flex: 1;
        flex-direction: row-reverse;
        align-items: center;

        /* float: right; */
    }

    #headLoginWrap .forgetPwd a {
        position: relative;

        /* top: 3px; */
        color: #29abe2;
    }

    #headLoginWrap .headLoginConfirmBtn {
        position: relative;
        display: block;
        width: 420px;
        padding: 0;
        margin: 30px auto 0;
        font-size: 20px;
        font-weight: bold;
        line-height: 40px;
        color: white;
        text-align: center;
        border-radius: 4px;

        &.loading {
            color: white;
            cursor: not-allowed;
            background-color: #88c9e4;
        }
    }

    #headLoginWrap .headLoginRegister {
        color: #29abe2;
        text-align: center;
    }

    #headLoginWrap .headLoginClose.iconfont.icon-chahao {
        position: absolute;
        top: 4px;
        right: 4px;
        font-size: 20px;
        cursor: pointer;
        transition: all 0.6s;
    }

    #headLoginWrap .headLoginClose.iconfont.icon-chahao:hover {
        transform: rotate(360deg);
    }
</style>
